// extracted by mini-css-extract-plugin
export default {"list":"styles_list__kNvAQ","list_item":"styles_list_item__WT01u"};